/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiBroadcastVoxtralCorrectorActiveEc2IpGet$Params {
  ec2Ip: string;
}

export function apiBroadcastVoxtralCorrectorActiveEc2IpGet(http: HttpClient, rootUrl: string, params: ApiBroadcastVoxtralCorrectorActiveEc2IpGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastVoxtralCorrectorActiveEc2IpGet.PATH, 'get');
  if (params) {
    rb.path('ec2Ip', params.ec2Ip, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastVoxtralCorrectorActiveEc2IpGet.PATH = '/api/Broadcast/voxtral/corrector-active/{ec2Ip}';
